import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import {
  invokeAllActivatedAdvertisers,
  selectedAdvertiser,
} from "src/app/store/advertiser/advertiser.actions";
import {
  advertisersSelector,
  selectedAdvertiserSelector,
} from "src/app/store/advertiser/advertiser.selectors";
import { AppStateInterface } from "src/app/store/appState.interface";
import { AdvertiserDetailsInterface } from "../../models/advertiser/profile.interface";
import { advertiserLoadingSelector } from "src/app/store/advertiser/advertiser.selectors";
import { catchForbiddenErrorSelector } from "src/app/store/user/user.selectors";
import { catchForbiddenError } from "src/app/store/user/user.actions";
import { FiltersService } from "../../services/filters.service";
@Component({
  selector: "app-advertisers",
  templateUrl: "./advertisers.component.html",
})
export class AdvertisersComponent extends BaseComponent implements OnInit {
  checked: boolean = false;
  advertisers$: Observable<string[] | null>;
  advertisers: string[] = [];
  savedAdvertisers: AdvertiserDetailsInterface[] = [];
  form: FormGroup;

  activatedAdvertisers$: Observable<AdvertiserDetailsInterface[] | null>;
  activatedAdvertisers: AdvertiserDetailsInterface[];
  loading$: Observable<boolean | null>;
  catchForbiddenError$: Observable<boolean | null>;
  forbidden: boolean | null = false;
  constructor(
    private store: Store<AppStateInterface>,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private filtersService : FiltersService
  ) {
    super(store);
    this.advertisers$ = this.store
      .pipe(select(selectedAdvertiserSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.activatedAdvertisers$ = this.store
      .pipe(select(advertisersSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.loading$ = this.store
      .pipe(select(advertiserLoadingSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.catchForbiddenError$ = this.store
      .pipe(select(catchForbiddenErrorSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.form = this.fb.group({
      email: [""],
    });

    this.extractFilters()
  }

  extractFilters() {
    const filters = this.filtersService.decodeUri();
    this.advertisers = this.filtersService.extractArrayValueFromUrl(
      filters,
      "advertisers",
      this.advertisers
    );
  }

  ngOnInit(): void {
    this.catchForbiddenError$.subscribe((result) => {
      if (result) {
        this.forbidden = true;
        this.store.dispatch(catchForbiddenError({ forbiddenError: null }));
      }
    });
    this.advertisers$.subscribe((data) => {
      if (data) {
        this.advertisers = data;
      }
    });
    this.store.dispatch(invokeAllActivatedAdvertisers());
    this.activatedAdvertisers$.subscribe((result) => {
      if (result) {
        this.activatedAdvertisers = result;
        this.savedAdvertisers = this.activatedAdvertisers;
      }
    });

    this.form.valueChanges.subscribe((values) => {
      this.searchTerm(values.email);
    });
  }
  searchTerm(email: string) {
    if (!email || email.trim() === '') {
      this.savedAdvertisers = this.activatedAdvertisers;
    } else {
      const searchValue = email.toLowerCase().trim();
      this.savedAdvertisers = this.activatedAdvertisers.filter((e) =>
        (e.email?.toLowerCase().includes(searchValue) ||
          e.firstName?.toLowerCase().includes(searchValue) ||
          e.lastName?.toLowerCase().includes(searchValue))
      );
    }
    this.cdr.detectChanges();
  }
  
  submit() {
    this.store.dispatch(
      selectedAdvertiser({ selectedAdvertiser: this.advertisers })
    );
    this.filtersService.updateMultipleQueryFilters({ advertisers: this.advertisers });
    const modal = this.modalService.dismissAll(AdvertisersComponent);
  }
  save(event: any, advertiser: string) {
    if (event.target.checked) {
      this.advertisers = [...this.advertisers, advertiser];
    } else {
      this.advertisers = this.advertisers.filter((item) => item != advertiser);
    }
  }
  onClickCloseModal() {
    this.modalService.dismissAll();
  }
}
